export default __webpack_public_path__ + "static/media/no_permission.97381645.png";